import React from 'react';
import capitalize from 'lodash/capitalize';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import moment from 'moment';
import { isManualVehicleVrm } from '@fxtr/i18n';
import GarageInfo from '$app/shared/components/GarageInfo/GarageInfo';
import Copyable from '$app/shared/components/Copyable';

const Vehicle = props => {
  const { make, model, vrm } = props.vehicle;
  const displayVrm = vrm && !isManualVehicleVrm(vrm) ? vrm : undefined;

  return (
    <div className='vehicle-info'>
      <p><span>{capitalize(make)} {capitalize(model)}</span><i className='icon-car pull-right' /></p>
      {displayVrm ? (
        <p>
          <span>{displayVrm}</span>
          <Copyable value={displayVrm}/>
        </p>
      ) : null}
    </div>
  )
}

const Garage = props => {
  const { garageInvites, quote } = props

  const accepted = garageInvites && garageInvites.find(gi => gi.status === 'accepted') || null
  const title = accepted ?
    (accepted.garage.contactPhone || accepted.garage.contactMobile) : null

  const lineItems = quote && quote.lineItems.map(li => <li key={li.operationId} title={li.workSummary}>{li.workSummary}</li>) || []

  return (
    <div className='garage-info'>
      {
        accepted &&
        <p className='garage-name'>
          <span title={title}>
            <GarageInfo garage={accepted.garage} />
          </span><i className='icon-wrench pull-right' />
        </p> || null
      }

      {
        lineItems.length !== 0 &&
        <ul className='work-operations'>
          {lineItems}
        </ul> || null
      }
    </div>
  )
}

const driverName = (id, drivers, collectionDeliveryOption) => {
  if (collectionDeliveryOption === 'CustomerC&D') return 'Customer C&D';

  if (!drivers) return id;

  const driver = drivers.find(d => d.driverId === id);

  return driver && `${driver.firstName} ${driver.lastName}` || id;
}

const Driver = props => {
  const { trips, drivers, masterStatusId, collectionDeliveryOption } = props

  const active = trips && trips.filter(t => t.status === 'active') || []

  if (active.length !== 0) {
    if (masterStatusId > 10200 && masterStatusId < 10600) {
      const customerGarageTrip = active.find(t => t.type === 'customer-garage')

      return (customerGarageTrip && customerGarageTrip.pickerId) && (
        !isEmpty(drivers) &&
        <div className='driver-info'>
          <p><span>{driverName(customerGarageTrip.pickerId, drivers, collectionDeliveryOption)}</span><i className='icon-hero pull-right' /></p>
        </div> || `Loading Hero ${customerGarageTrip.pickerId}`
      ) || 'Collection driver not assigned'
    }

    if (masterStatusId >= 10600) {
      const garageCustomerTrip = active.find(t => t.type === 'garage-customer');

      return (garageCustomerTrip && garageCustomerTrip.pickerId) && (
        !isEmpty(drivers) &&
        <div className='driver-info'>
          <p><span>{driverName(garageCustomerTrip.pickerId, drivers, collectionDeliveryOption)}</span><i className='icon-hero pull-right' /></p>
        </div> || `Loading Hero ${garageCustomerTrip.pickerId}`
      ) || 'Delivery driver not assigned'
    }
    return null
  }
  return null
}

const Footer = props => {
  const {
    location,
    collectionDateTimeLocal,
    deliveryDateTimeLocal,
    collectionNote
  } = props

  return (
    <div className='card-footer'>
      <p>
        <span>{location.territory || location.city}</span>
        <i className='icon-calendar pull-right' />
      </p>
      <p className="date-time">
        {moment(collectionDateTimeLocal).format('h:mma - Do MMM YY')}
        <br />
        {moment(deliveryDateTimeLocal).format('h:mma - Do MMM YY')}
      </p>
      {collectionNote && (
        <p className='collection-note' title={collectionNote}>
          « {collectionNote} »
        </p>
      )}

    </div>
  )
}

const NoteCM = props => {
  const { notes } = props

  const active = notes.filter(n => n.status === 'ACTIVE' && !includes(['customer-to-mechanic', 'seen-note-marker'], n.noteType))
  return (active && active.length > 0) && (
    <div className='cm-note'>
      <p title={active[0].content}>
        {active[0].content}
      </p><span className='pull-right'><i className='icon-note' /></span>
    </div>
  ) || null
}

const Body = props => {
  const {
    vehicle,
    garageInvites,
    quote,
    trips,
    masterStatusId,
    garage,
    collectionAddress,
    collectionDateTimeLocal,
    deliveryDateTimeLocal,
    collectionNote,
    notes,
    collectionDeliveryOption,
  } = props.booking

  return (
    <div className='card-body'>
      <div className='card-details'>
        <Vehicle vehicle={vehicle} />
        <Garage
          garageInvites={garageInvites}
          quote={quote}
        />
        <Driver
          trips={trips}
          drivers={props.drivers}
          masterStatusId={masterStatusId}
          collectionDeliveryOption={collectionDeliveryOption}
        />
      </div>
      <div className='horizontal-line' />
      <Footer
        location={garage || collectionAddress}
        collectionDateTimeLocal={collectionDateTimeLocal}
        deliveryDateTimeLocal={deliveryDateTimeLocal}
        collectionNote={collectionNote}
      />
      <NoteCM notes={notes} />
    </div>
  )
}

export default Body
